import React from 'react'
import styles from './FirstView.module.css'

export default function FirstView() {
    return (
        <div className={styles.fvBackground}>
            <div className={styles.fvWidth}>
                <div className={styles.logo}>
                    <img
                        src='/pages/business/foodslabo/logo.png'
                        alt='Foodslaboのロゴ'
                    />
                </div>
                <h1 className={styles.h1Pc}>
                    <img
                        src='/pages/business/foodslabo/fv_text.png'
                        alt='業界初採用までのコスト0円の採用DXプラットフォーム'
                    />
                </h1>
                <h1 className={styles.h1Sp}>
                    <img
                        src='/pages/business/foodslabo/fv_text_sp.png'
                        alt='業界初採用までのコスト0円の採用DXプラットフォーム'
                    />
                </h1>
                <ul className={styles.fvPointsList}>
                    <li className={`${styles.fvPointItem} ${styles.fvPoint1}`}>
                        <p className={styles.fvPointText}>
                            初期費用
                            <br />
                            求人掲載0円
                        </p>
                    </li>
                    <li className={`${styles.fvPointItem} ${styles.fvPoint2}`}>
                        <p className={styles.fvPointText}>
                            求人作り放題
                            <br />
                            スカウト無料
                        </p>
                    </li>
                    <li className={`${styles.fvPointItem} ${styles.fvPoint3}`}>
                        <p className={styles.fvPointText}>
                            求人掲載期間
                            <br />
                            無期限
                        </p>
                    </li>
                </ul>
                <a
                    href='#form'
                    rel='noopener noreferrer'
                    className={styles.fvLink}
                >
                    お問い合わせはこちら
                </a>
            </div>
        </div>
    )
}
